import { useWalletAddress } from '@/features/account-abstraction/hooks/useWalletAddress';
import { Copy } from 'lucide-react';
import { toast } from '@/components/toast/useToast';
import Callout from '@/components/Callout/Callout';
// import TextDivider from '@/features/user-profile/components/TextDivider';
// import Button from '@/components/new-design/Button';

const DepositTab = () => {
  const { walletAddress } = useWalletAddress();

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(walletAddress || '');
      toast({ description: 'Copied to clipboard', variant: 'success' });
    } catch (err) {
      console.error('Failed to copy: ', err);
    }
  };

  return (
    <div className="mt-6 flex min-h-[19em] min-w-[min(650px,calc(100vw-50px))] max-w-[650px] flex-col gap-6">
      <div className="flex flex-col gap-2">
        <p className="text-sm text-ph-white-50">
          Please make sure you use the <span className="font-bold text-ph-white">Polygon network</span> to deposit funds
          into your Phenom Poker wallet. You can copy the deposit address below:
        </p>
      </div>
      <div className="flex items-center justify-between rounded-lg bg-ph-white-3 p-4">
        <span className="mr-2 truncate font-mono text-sm text-white">{walletAddress}</span>
        <button
          onClick={copyToClipboard}
          className="text-gray-400 transition-colors duration-200 hover:text-white"
          aria-label="Copy wallet address"
        >
          <Copy size={20} />
        </button>
      </div>
      <Callout variant="warning">
        IMPORTANT: Only send USDT on Polygon. Sending USDT or any other assets on a different chain (such as Ethereum)
        will result in PERMANENT LOSS OF FUNDS
      </Callout>
      {/*<TextDivider />*/}
      {/*<div className="flex flex-col gap-2">*/}
      {/*  <h3 className="text-lg font-semibold">MoonPay Deposit</h3>*/}
      {/*  <p className="text-sm text-ph-white-50">*/}
      {/*    Lorem ipsum dolor sit amet consectetur. Ut nunc sed libero lorem. Pellentesque scelerisque ornare tellus velit*/}
      {/*    mauris eu sodales.*/}
      {/*  </p>*/}
      {/*  <Button className="mt-2 max-w-40">Deposit via MoonPay</Button>*/}
      {/*</div>*/}
    </div>
  );
};

export default DepositTab;
